import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleSection() {
  const latestArticles = articles.slice(0, 3);

  return (
    <section>
      <div className="flex items-end justify-between mb-5">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-100">影视资讯</h2>
          <p className="text-sm text-foreground-400 mt-1">最新电影资讯与深度影评</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {latestArticles.map((article) => (
          <Link
            key={article.id}
            to={`/article/${article.id}`}
            className="group cursor-pointer rounded-xl overflow-hidden bg-background-100/60 hover:bg-background-200/60 transition-colors"
          >
            <div className="aspect-[16/9] overflow-hidden">
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 rounded-full bg-secondary-500/20 text-secondary-400 text-xs font-medium">
                  {article.category}
                </span>
                <span className="text-xs text-foreground-400">{article.publishDate}</span>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors line-clamp-2">
                {article.title}
              </h3>
              <p className="text-sm text-foreground-400 mt-2 line-clamp-2">{article.summary}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}